const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GA_ID = process.env.REACT_APP_GA_ID;

let gaLoaded = false;

export function getSessionId() {
  let id = localStorage.getItem("fd_sid");
  if (!id) {
    id = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("fd_sid", id);
  }
  return id;
}

export function isInternal() {
  return localStorage.getItem("fd_internal") === "on";
}

export function setInternal(on) {
  if (on) localStorage.setItem("fd_internal", "on");
  else localStorage.removeItem("fd_internal");
}

export function trackPageview(path) {
  if (isInternal()) return;
  if (path.startsWith("/admin") || path.startsWith("/login")) return;
  try {
    fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path, referrer: document.referrer || "", session_id: getSessionId() }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {}
}

export function getConsent() {
  return localStorage.getItem("fd_consent"); // "granted" | "denied" | null
}

export function setConsent(value) {
  localStorage.setItem("fd_consent", value);
  if (value === "granted") {
    loadGA();
    // Send an immediate page_view so GA Real-time lights up right after consent
    gaPageview(window.location.pathname);
  }
}

export function loadGA() {
  if (gaLoaded || !GA_ID || isInternal()) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

export function gaPageview(path) {
  if (!gaLoaded || !GA_ID || !window.gtag || isInternal()) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export const hasGA = !!GA_ID;
